import React from 'react';
import UIStrings from '@/Utils/UIStrings';
import { Button } from '@/Components/shadcn';
import { cn } from '@/lib/utils';
import InformationOptionLabel from './InformationOptionLabel';

interface MandatoryInformationOptionProps {
    label: string;
}

const MandatoryInformationOption = ({ label }: MandatoryInformationOptionProps): React.JSX.Element => {
    return (
        <div className="flex flex-row flex-wrap items-center justify-between gap-4 px-10 py-4">
            <InformationOptionLabel label={label} />
            <Button type="button" size="sm" variant="default" className={cn('min-w-24 px-4')}>
                {UIStrings.Mandatory}
            </Button>
        </div>
    );
};

export default MandatoryInformationOption;
